// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"8de2748f","453":"41eab1ad","759":"2c3aed11"}[chunkId] + ".chunk.js";
};